/*
====================================================================
           Clase CambiarContraseñaEntity
====================================================================
Esta clase representa una entidad para manejar la lógica relacionada 
con la confirmación del restablecimiento de la contraseña. Incluye 
propiedades para almacenar la contraseña antigua, la nueva contraseña 
del usuario y la confirmación de la misma, así como métodos para validar 
que las nuevas contraseñas coincidan y cumplan con los requisitos de 
seguridad de AWS Cognito.

====================================================================
*/

// ------------------------------------------------------------------
//                       DEFINICIÓN DE LA CLASE
// ------------------------------------------------------------------
/**
 * Clase que representa una entidad de confirmación de cambio de contraseña.
 * 
 * Esta clase encapsula los datos necesarios para confirmar el cambio 
 * de contraseña y proporciona métodos para validar que las nuevas contraseñas 
 * cumplan con los requisitos de seguridad.
 */
class CambiarContraseñaEntity {
  /**
   * Constructor de la clase CambiarContraseñaEntity.
   * 
   * @param {string} password_old - La contraseña actual o temporal del usuario.
   * @param {string} password_nueva - La nueva contraseña del usuario.
   * @param {string} password_nueva_repetida - La repetición de la nueva contraseña para confirmar que coinciden.
   */
  constructor(password_old = '', password_nueva = '', password_nueva_repetida = '') {
    this.password_old = password_old.trim(); // Contraseña actual o temporal
    this.password_nueva = password_nueva.trim(); // Nueva contraseña
    this.password_nueva_repetida = password_nueva_repetida.trim(); // Confirmación de la nueva contraseña
  }

  /**
   * Método para validar que las contraseñas sean correctas y cumplan con los requisitos de AWS Cognito.
   * 
   * Valida que la nueva contraseña y su repetición sean iguales, que la nueva contraseña sea 
   * distinta a la actual, y que cumpla con los requisitos de longitud y complejidad (letra mayúscula, 
   * minúscula, número y carácter especial).
   * 
   * @returns {string[]} Un array de mensajes de error, si los hay.
   */
  validar() {
    const errores = [];

    // Validar que la nueva contraseña sea diferente a la contraseña actual
    if (this.password_old === this.password_nueva) {
      errores.push("La nueva contraseña no puede ser igual a la anterior.");
    }
    console.log(this.password_nueva !== this.password_nueva_repetida)
    console.log( this.password_nueva_repetida)
    console.log(this.password_nueva)

    // Validar que ambas nuevas contraseñas sean iguales
    if (this.password_nueva !== this.password_nueva_repetida) {
      errores.push("Las contraseñas no coinciden.");
    }

    // Validar que la nueva contraseña cumpla con los requisitos de AWS Cognito
    const cognitoPasswordPattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

    if (!cognitoPasswordPattern.test(this.password_nueva)) {
      errores.push("La nueva contraseña debe tener al menos 8 caracteres, incluyendo una letra mayúscula, una minúscula, un número y un carácter especial.");
    }

    return errores;
  }
}

export default CambiarContraseñaEntity;
